(async function () {
    // save the section id from the script tag and find the section
    const sectionID = document.currentScript.dataset.id;
    const section = document.querySelector(`#${sectionID}`);

    let activeVariant;
    let product = JSON.parse(section.querySelector('.templateProductJSON').textContent)

    // exit if section is not found
    if (!section) {
        console.warn(`Product section with ID ${sectionID} not found.`);
        return;
    }

    let quantity = 1;

    // during dev mode, set the active variant to the window so it can be accessed in the console
    if (Shopify.theme.role === "development") {
        window.product = product;
        window.activeVariant = activeVariant;
    }


    let visibilitySettingsMap = {
        "all": {
            "one_time": true,
            "pack_sizes": [1, 3, 5]
        },
        "b2_sub_one_time": {
            "one_time": true,
            "pack_sizes": [4]
        },
        "b2_sub": {
            "one_time": false,
            "pack_sizes": [4]
        },
        "b3_sub_one_time": {
            "one_time": true,
            "pack_sizes": [6]
        },
        "b3_sub": {
            "one_time": false,
            "pack_sizes": [6]
        }
    }
    let visibilitySettings = visibilitySettingsMap[section.dataset.visibility];

    // hide one-time option
    if (!visibilitySettings.one_time) {
        section.querySelectorAll('.productV3FormPlanLabel.once').forEach(function (el) {
            el.classList.remove('active');
        })
    }

    // filter product pack sizes
    subscriptionProducts.forEach(function (el) {
        let packSize = parseInt(el.sku.split('-')[1].replace(/[SsXx]/g, ''));
        if (!visibilitySettings.pack_sizes.includes(packSize)) {
            let index = subscriptionProducts.indexOf(el);
            if (index > -1) {
                subscriptionProducts.splice(index, 1);
            }
        }
    })
    oneTimeProducts.forEach(function (el) {
        let packSize = parseInt(el.sku.split('-')[1].replace(/[SsXx]/g, ''));
        if (!visibilitySettings.pack_sizes.includes(packSize)) {
            let index = oneTimeProducts.indexOf(el);
            if (index > -1) {
                oneTimeProducts.splice(index, 1);
            }
        }
    })

    /************
     Product Swiper
     ************/

    section.querySelectorAll('.productV3').forEach(function (element) {
        new Swiper(element.querySelector('.productV3VisualSwiper'), {
            navigation: {
                nextEl: element.querySelector('.swiper-button-next'),
                prevEl: element.querySelector('.swiper-button-prev'),
            }
        })

        element.querySelectorAll(`.productV3VisualThumbsThumbnail`).forEach(function (thumb) {
            thumb.addEventListener("click", function () {

                // determine index
                let index = getElIndex(this);

                // change active slide
                element.querySelector('.productV3VisualSwiper').swiper.slideTo(index);
            });
        });
    })


    /************
     Switch Products
     ************/
    section.querySelectorAll('.productV3ProductsChoice').forEach(function (button) {
        button.addEventListener("click", function () {
            let target = this.dataset.id;
            let activeProductSection = section.querySelector('.productV3.active');


            // add active class to the selected product choice (there are 3 of them total, not 1)
            section.querySelectorAll('.productV3ProductsChoice').forEach(function (element) {
                if (element.dataset.id === target) {
                    element.classList.add('active');
                } else {
                    element.classList.remove('active');
                }
            });

            // reselect the same pack size index on the new product section
            let currentPackIndex = activeProductSection.querySelector('.productV3FormVariantLabelInput:checked').dataset.index;
            let newProductSection = section.querySelector(`.productV3[data-id='${target}']`);
            newProductSection.querySelectorAll('.productV3FormVariantLabelInput').forEach(function (input) {
                if (input.dataset.index === currentPackIndex) {
                    input.checked = true;
                }
            })

            // reselect same subscription/one-time plan on the new product section
            let currentPlan = activeProductSection.querySelector('.productV3FormPlanLabelInput:checked').value;
            newProductSection.querySelectorAll('.productV3FormPlanLabelInput').forEach(function (input) {
                if (input.value === currentPlan) {
                    input.checked = true;
                }
            })

            // show the selected product content
            section.querySelectorAll('.productV3').forEach(function (element) {
                if (element.dataset.id === target) {
                    element.classList.add('active');
                } else {
                    element.classList.remove('active');
                }
            })

            updateProduct()
        })
    })


    /**
     * Build the variant options HTML
     * @param {Array} products - Array of product objects,
     * each containing variant selector information.
     */

    function constructVariantOptions(products) {
        section.querySelectorAll('.productV3FormVariant').forEach(function (element, outerIndex) {
            element.innerHTML = '';
            let HTML = '';
            products.forEach(function (product, index) {
                let checked
                if (products.length > 1) {
                    checked = index === 1 ? 'checked' : '';
                } else {
                    checked = index === 0 ? 'checked' : '';
                }

                HTML += `
                <label class="productV3FormVariantLabel">
                    <input class="productV3FormVariantLabelInput" type="radio" name="${sectionID}-${outerIndex}-variant"
                           value="${product.id}" ${checked} data-index="${index}"
                           data-size="${product.variant_selector.pack_size}">
                    <span class="productV3FormVariantItem">
                         <span class="productV3FormVariantItemTag">${product.variant_selector.label}</span>
                         <span class="productV3FormVariantItemTag mobile">${product.variant_selector.mobile_label}</span>
                         <span class="productV3FormVariantItemTitle">${product.variant_selector.title}</span>
                         <span class="productV3FormVariantItemInterval">${product.variant_selector.shipping_interval}</span>
                         <span class="productV3FormVariantItemUnitPrice">${product.variant_selector.per_price}</span>
                    </span>
                </label>
            `;
            });
            // element HTML
            element.innerHTML = HTML;
        })
    }

    // initialize the variant options with the subscription products
    // init with wintergreen
    let wintergreenSubscriptionProducts = [];
    subscriptionProducts.forEach(function (product) {
        if (product.sku.split('-')[0] === 'LIV1153') {
            wintergreenSubscriptionProducts.push(product);
        }
    })
    constructVariantOptions(wintergreenSubscriptionProducts);

    // update product on variant change
    section.querySelectorAll('.productV3FormVariantLabelInput').forEach(function (input) {
        input.addEventListener('change', function () {
            updateProduct();
        });
    })

    // update variant options on plan change
    section.querySelectorAll('.productV3FormPlanLabelInput').forEach(function (input) {
        input.addEventListener('change', function () {
            // update product
            updateProduct();
        });
    })


    function isSubscription() {
        let activeProductSection = section.querySelector('.productV3.active');
        return activeProductSection.querySelector('.productV3FormPlanLabelInput:checked')?.value === 'sub';
    }

    /**************
     Update Product
     ***************/

    async function updateProduct() {

        let activeProductSection = section.querySelector('.productV3.active');


        // rebuild the variant options based on the selected plan
        let products = isSubscription() ? subscriptionProducts : oneTimeProducts;
        let targetSKUPrefix = section.querySelector('.productV3ProductsChoice.active').dataset.sku.trim();
        products = products.filter(function (product) {
            return product.sku.startsWith(targetSKUPrefix);
        })

        activeProductSection.querySelectorAll('.productV3FormVariantLabel').forEach(function (element, index) {
            let product = products[index];

            // update element
            element.querySelector('.productV3FormVariantLabelInput').value = product.id;
            element.querySelector('.productV3FormVariantItemTag').textContent = product.variant_selector.label;
            element.querySelector('.productV3FormVariantItemTag.mobile').textContent = product.variant_selector.mobile_label;
            element.querySelector('.productV3FormVariantItemTitle').textContent = product.variant_selector.title;
            element.querySelector('.productV3FormVariantItemInterval').textContent = product.variant_selector.shipping_interval;
            element.querySelector('.productV3FormVariantItemUnitPrice').textContent = product.variant_selector.per_price;
        })

        // if it's one time, hide shipping interval
        activeProductSection.querySelectorAll('.productV3FormVariantItemInterval').forEach(function (el) {
            if (!isSubscription()) {
                el.classList.remove('active');
            } else {
                el.classList.add('active');
            }
        });


        // find the selected product
        let selectedProductId = parseInt(activeProductSection.querySelector('.productV3FormVariantLabelInput:checked').value);

        // find the active variant
        activeVariant = products.find(product => product.id === selectedProductId);

        // find the one time version of the active variant
        let skuPrefix = activeVariant.sku.split('-')[0]; // LIV1153-3X or LIV1153-3S
        let skuType = activeVariant.sku.split('-')[1]; // 3S

        // pack size is the first letter of SKU (3)
        let packSize = skuType.replace(/[SsXx]/g, ''); // remove S or X
        let oneTimeSku = `${skuPrefix}-${packSize}X`;
        let subSku = `${skuPrefix}-${packSize}S`;

        let oneTimeVariant = oneTimeProducts.find(product => product.sku === oneTimeSku);
        let subVariant = subscriptionProducts.find(product => product.sku === subSku);

        // update price display
        activeProductSection.querySelector('.productV3FormPlanLabelBodyActual.sub').textContent = price(subVariant.price, true);
        activeProductSection.querySelector('.productV3FormPlanLabelBodyActual.once').textContent = price(oneTimeVariant.price, true);

        // update active image
        if (activeVariant.featured_image) {
            // change active slide
            activeProductSection.querySelector('.productV3VisualSwiperImage').src = activeVariant.featured_image;
        }

        // update Subscription selector save amount
        activeProductSection.querySelector('.productV3FormPlanLabelBodyListItem').textContent = "Subscribe & save " + subVariant.savings;

        if (Shopify.theme.role === "development") {
            window.activeVariant = activeVariant;
        }

        // available
        if (activeVariant.available) {
            activeProductSection.querySelector('.productV3FormATC').textContent = "ADD TO CART"
            activeProductSection.querySelector('.productV3FormATC').disabled = false;
            activeProductSection.querySelector('.productV3StickyBodyRightATCTxt').textContent = "ADD TO CART"
            activeProductSection.querySelector('.productV3StickyBodyRightATC').disabled = false;
        } else {
            activeProductSection.querySelector('.productV3FormATC').textContent = "SOLD OUT"
            activeProductSection.querySelector('.productV3FormATC').disabled = true;
            activeProductSection.querySelector('.productV3StickyBodyRightATCTxt').textContent = "SOLD OUT"
            activeProductSection.querySelector('.productV3StickyBodyRightATC').disabled = true;
        }

        // Update sticky ATC
        activeProductSection.querySelector(".productV3StickyBodyRightOptionAmount").textContent = activeVariant.variant_selector.title;
        activeProductSection.querySelector(".productV3StickyBodyLeftMobileAmount").textContent = activeVariant.variant_selector.title;
        activeProductSection.querySelector(".productV3StickyBodyRightOptionInterval").textContent = activeVariant.variant_selector.shipping_interval ?? "";
        activeProductSection.querySelector(".productV3StickyBodyLeftMobileInterval").textContent = activeVariant.variant_selector.shipping_interval ?? "";
        activeProductSection.querySelector(".productV3StickyBodyRightATCCompare").textContent = activeVariant.compare_at_price ? price(activeVariant.compare_at_price) : "";
        activeProductSection.querySelector(".productV3StickyBodyRightATCPrice").textContent = price(activeVariant.price);


        // B2B Selling plan
        let sellingPlanSelect = activeProductSection.querySelector('.productV3FormPlanSelect') || false;
        if (sellingPlanSelect) {
            // add in selling plans
            let HTML = '';
            subVariant.selling_plans.forEach(function (plan) {
                HTML += `
                    <option value="${plan.id}">${plan.name}</option>
                `;
            });
            sellingPlanSelect.innerHTML = HTML;
        }

        // update info section

        const skuToFlavor = {
            'LIV1153': 'wintergreen',
            'LIV2254': 'peppermint',
            'LIV3365': 'mild',
            'LIV6655': 'arctic'
        }
        let flavor = skuToFlavor[skuPrefix];
        section.querySelectorAll('.productV3Info').forEach(function (element) {
            if (element.dataset.flavor === flavor) {
                element.classList.add('active');
            } else {
                element.classList.remove('active');
            }
        })

    }

    // on load, update the product
    // this accomplishes loading the correct variant image and price on page load
    updateProduct();


    // auto select query params
    let urlParams = new URLSearchParams(window.location.search);
    let flavor = urlParams.get('flavor');
    let packSize = urlParams.get('size');

    if (flavor) {
        // only allow known flavors
        let validFlavors = ['wintergreen', 'peppermint', 'mild', 'arctic'];
        if (validFlavors.includes(flavor.toLowerCase())) {
            let flavorTarget = section.querySelector(`.productV3ProductsChoice.${flavor.toLowerCase()}`) || false;
            if (flavorTarget) flavorTarget.click();
        }
    }

    if (packSize) {
        section.querySelectorAll('.productV3FormVariantLabelInput')?.forEach(function (input) {
            if (packSize === input.dataset.size) {
                input.click();
            }
        })

    }


    /**************
     Product ATC
     ***************/
    async function addToCart() {
        let activeProductSection = section.querySelector('.productV3.active');

        // add loading animation to both buttons
        activeProductSection.querySelector(".productV3FormATC").classList.add("loading");

        let sellingPlan = activeVariant.plan_id || null

        // B2B Selling plan select override
        let sellingPlanSelect = section.querySelector('.productV3FormPlanSelect') || false;
        if (sellingPlanSelect && isSubscription()) {
            sellingPlan = parseInt(sellingPlanSelect.value);
        }

        let formData = {
            items: [{
                quantity: quantity,
                id: activeVariant.variant_id,
                selling_plan: sellingPlan
            }]
        };

        // add product
        await addProduct(formData);

        // remove loading animation
        activeProductSection.querySelector(".productV3FormATC").classList.remove("loading");

        // open cart
        await openCart();

        // record GA4 & Klaviyo tracking
        await tracking(formData);
    }

    section.querySelectorAll(".productV3FormATC").forEach(function (button) {
        button.addEventListener("click", addToCart);
    })

    // Reviews scroll
    section.querySelector('.productV3DropsItemBodyReviews').addEventListener("click", function () {
        // scroll to section of page with reviewsTarget (reviewsTarget is created in the FAQ section, based on section.id)
        window.scroll({
            top: document.querySelector(`#${reviewsTarget}`).offsetTop - 100,
            behavior: "smooth"
        })
    })

    /**************
     STICKY ATC
     ***************/
    section.querySelectorAll('.productV3StickyBodyRightATC').forEach(function (el) {
        el.addEventListener('click', function () {
            // add loading animation
            this.classList.add('loading');

            addToCart();

            // wait 1 second
            setTimeout(function () {
                // remove loading animation
                el.classList.remove('loading');
            }, 1000);
        });
    });

    /************
     Dynamic Sold Out
     ************/
    (function () {
        // Get the current date and time
        let currentDate = new Date();
        // let currentDate = new Date("2024-05-29T23:59:00");

        // The date everything is relative to - which is a Sunday.
        let targetDate = new Date("2024-04-28T23:59:00");

        // Increment the counter for every day that has passed
        let daysPassed = Math.floor((currentDate - targetDate) / (1000 * 60 * 60 * 24) % 7);

        // get the next monday from current date
        let nextMonday = new Date(currentDate);
        nextMonday.setDate(currentDate.getDate() + 8 - currentDate.getDay());

        // get the last monday from current date
        let lastMonday = new Date(currentDate);
        lastMonday.setDate(currentDate.getDate() + 1 - currentDate.getDay());

        // Update the text with the incremented number
        section.querySelectorAll(".percentSold")?.forEach(function (element) {
            element.textContent = daysPassed + 91;
        });

        // Update the date with the next monday
        section.querySelectorAll(".preOrderDate")?.forEach(function (element) {
            element.textContent = nextMonday.toLocaleDateString('en-US', {month: 'long', day: 'numeric'});
        });

        // Update the date with the last Monday
        section.querySelectorAll(".lastOrderDate")?.forEach(function (element) {
            element.textContent = lastMonday.toLocaleDateString('en-US', {month: 'long', day: 'numeric'});
        });
    })();


    // dropdown event listeners for each of the titles
    section.querySelectorAll(`.productV3DropsItemTitle`).forEach(function (element) {
        element.addEventListener("click", function () {
            this.parentElement.classList.toggle("active");
        });
    });

    // random number gen (23-100) for checking out now text
    section.querySelectorAll(".productV3CheckingOutNum").forEach(function (element) {
        element.innerHTML = Math.floor(Math.random() * (127 - 70 + 1) + 70); // make range 70 - 127
    });
    // Do it every 3 seconds
    setInterval(function () {
        section.querySelectorAll(".productV3CheckingOutNum").forEach(function (element) {
            element.innerHTML = Math.floor(Math.random() * (127 - 70 + 1) + 70); // make range 70 - 127
        });
    }, 3000);


    /************
     GA4 & Klaviyo Tracking
     ************/
    async function tracking(formData) {

        // GA4 add_to_cart
        const sourceProduct = activeVariant.product;
        dataLayer.push({ecommerce: null});
        dataLayer.push({
            event: 'add_to_cart',
            ecommerce: {
                currency: Shopify.currency.active,
                value: sourceProduct.variants[0].price * quantity / 100,
                items: [{
                    item_id: sourceProduct.id,
                    item_name: sourceProduct.title,
                    item_category: sourceProduct.type,
                    item_variant: sourceProduct.variants[0].title,
                    price: sourceProduct.variants[0].price / 100,
                    quantity: quantity,
                    subscription_item: !!formData.selling_plan,
                }],
                subscription_included: !!formData.selling_plan,
            }
        });

        // push to klavviyo
        try {
            _learnq.push(["track", "Added to Cart", {
                "$value": sourceProduct.price * quantity / 100,
                "AddedItemProductName": sourceProduct.title,
                "AddedItemProductID": sourceProduct.id,
                "AddedItemSKU": sourceProduct.variants[0].sku,
                "AddedItemCategories": sourceProduct.tags,
                "AddedItemImageURL": sourceProduct.featured_image?.src,
                "AddedItemURL": `https://getlivfresh.com/products/${product.handle}`,
                "AddedItemPrice": sourceProduct.price,
                "AddedItemQuantity": 1,
                "ItemNames": [sourceProduct.title],
                "CheckoutURL": "https://livfresh.com/checkout",
                "Items": [{
                    "ProductID": sourceProduct.id,
                    "SKU": sourceProduct.variants[0].sku,
                    "ProductName": sourceProduct.title,
                    "Quantity": quantity,
                    "ItemPrice": sourceProduct.price / 100,
                    "RowTotal": sourceProduct.price * quantity / 100,
                    "ProductURL": `https://getlivfresh.com/products/${product.handle}`,
                    "ImageURL": sourceProduct.featured_image?.src,
                    "ProductCategories": sourceProduct.tags
                }]
            }]);
        } catch (e) {
            console.log(e)
        }
    }


}());